import * as React from 'react';
import { Wrapper, Container, LogoContainer, InfoContainer, Text } from './SchoolInfo.styles';
import type { SchoolInfoProps } from './SchoolInfo.types';

export const SchoolInfo = ({ logo, text }: SchoolInfoProps): React.ReactElement<any> => (
  <Wrapper>
    <Container>
      <LogoContainer>
        <img src={logo} alt='School logo' loading='lazy' width='100%' height='100%' />
      </LogoContainer>
      <InfoContainer>
        {/* TODO: Temporary commented meanwhile we don't have Heading text from contentful <Title>{title}</Title> */}
        <Text> {text}</Text>
      </InfoContainer>
    </Container>
  </Wrapper>
);
